<template>
  <div class="buzon">
    <div class="row not-margin">
      <div class="col-md-12 container-info">
        <div class="row info margin-zero">
          <div class="col-lg-2 padding-zero">
            <h1>
              <img src="../assets/images/user.png" /> {{ $t('inbox.inbox') }}
            </h1>
          </div>
        </div>
        <div class="row info margin-zero">
          <div class="col-md-4 padding-zero"><input v-model="tituloMensaje" type="text" class="inp" :placeholder="$t('inbox.title')" /></div>
          <div class="col-md-8 padding-zero"><input v-model="mensaje" type="text" class="inpf" :placeholder="$t('inbox.content')" /></div>
          <p class="error" v-if="errorMensaje != ''" >* {{errorMensaje}}</p>
          <button v-on:click="saveMessage" class="btn send-b">{{ $t('inbox.send') }}</button>
        </div>
      </div>
    </div>

    <div class="container-info margin-between-section">
      <table class="table table-condensed container-info margin-between-section tb-header" style="border-collapse:collapse;">
        <thead>
          <tr>
            <th>{{$t('inbox.user')}}</th>
            <th>{{$t('inbox.title_table')}}</th>
            <th>{{$t('inbox.date')}}</th>
            <!--<th class="show-desktop">Acciones</th>-->
          </tr>
        </thead>
        <tbody id="accordion">
          <template v-for="(value, index) in data">
          
          <tr :key="index" :class="{'done-row': index == selectedUser}" class="accordion-toggle t-border">
            <td v-on:click="handleRow(index)" data-toggle="collapse" :data-target="'#detail' + index" >{{value.from}} </td>
            <td v-on:click="handleRow(index)" data-toggle="collapse" :data-target="'#detail' + index" >{{value.title}}</td>
            <td v-on:click="handleRow(index)" data-toggle="collapse" :data-target="'#detail' + index">{{value.fecha}}</td>
            <!--<td ><button v-on:click="deleteInfo(value)" class="delete_user"></button></td>-->
          </tr>
          <tr :key="value.id" :id="'detail'+index" data-parent="#accordion" class="collapse">
            <td colspan="12" class="hiddenRow">
              <div class="accordian-body" >
                <template>
                  <div class="fullwidth">
                    <div class="row">
                      <div v-for="(content, index) in value.messages" :key="index" class="col-md-12 infoMessage">
                        <p ><span v-if="content.type == 'Send'">{{$t('inbox.reply')}}:</span><span v-else>{{$t('inbox.send_me')}}:</span> <strong>{{ content.timestamp}}</strong></p>
                        <p>{{$t('inbox.message')}}: <br><strong>"{{content.message}}"</strong></p>
                      </div>
                      <div class="group">
                        <input v-model="respuesta" class="input-form" type="text" :placeholder="$t('inbox.write_response')" />
                      </div>
                      <p class="error" v-if="error != ''" >* {{error}}</p>
                      <div class="">
                        <button v-on:click="saveResponse(value.title, value.inboxId)" type="btn" class="btn btn-action m-top-margin">{{$t('inbox.send')}}</button>
                      </div>   
                    </div>
                  </div>
                </template>
              </div> 
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import Inbox from '../parse/models/Inbox'
import json from "@/assets/data/message.json";
import { bus } from "../main";

export default {
  name: "buzon",
  data() {
    
    return {
      data: [],
      defaultOpenedDetails: [],
      showDetailIcon: false,
      notification: {
        disable: true,
        id: "",
        name: "",
        message: "",
      },
      error: "",
      errorMensaje: "",
      respuesta: "",
      tituloMensaje: "",
      mensaje: "",
      inboxIdReload: "",
      selectedUser: null
    };
  },
  beforeMount() {
    Inbox.load().then((message) => {
      message.forEach(value => 
        this.data.push({
          id: value.id,
          to: value.to,
          from: value.from,
          messages: value.messages,
          title: value.title,
          fecha: value.date,
          inboxId: value.inboxId
        })
      )
    })
  },
  components: {},
  methods: {
    create(){
      this.$router.push('/create')
    },
    toggle(row) {
      this.$refs.table.toggleDetails(row);
    },
    closeAllOtherDetails(row, index) {
      this.defaultOpenedDetails = [row.id];
    },
    handleRow(index){
      if(this.selectedUser == index){
        this.selectedUser = null;
      } else {
        this.selectedUser = index;
      }
    },
    handleSelectItem(item) {
      console.log(item)
    },
    deleteInfo(user) {
      console.log(user.id)
    },
    saveMessage(){

      if( this.tituloMensaje == ""){
        this.errorMensaje = this.$t('inbox.enter_title')
        return;
      }
      if( this.mensaje == ""){
        this.errorMensaje = this.$t('inbox.write_message')
        return;
      }

      this.notificationerror = {
        disable: false,
        sampleMessage: true,
        message: this.$t('notification.error')
      }

      let idiom = ""

      if (localStorage.idiom){
        idiom = localStorage.idiom 
      }
      
      const data = this.$parse.User.current()
      const params = {
        title: this.tituloMensaje,
        message: this.mensaje,
        inboxId: "",
        lang: idiom
      }

      Inbox.saveMessage(params)
      .then((user) => this.sampleReloadM())
      .catch(error => bus.$emit('sample', this.notificationerror))

      this.errorMensaje = ""
    },

    saveResponse(title, id){

      this.inboxIdReload = id
      
      if(this.respuesta == ""){
        this.error = this.$t('inbox.write_message')
        return;
      }

      this.notificationerror = {
        disable: false,
        sampleMessage: true,
        message: this.$t('notification.error')
      }

      const data = this.$parse.User.current()
      const params = {
        title: "",
        message: this.respuesta,
        inboxId: id
      }
  
      Inbox.saveMessage(params)
      .then((user) => this.sampleReload())
      .catch(error => bus.$emit('sample', this.notificationerror))

      this.error = ""
    },

    sampleReloadM(){

      this.tituloMensaje = "",
      this.mensaje = ""
      this.respuesta = ""

      this.notification = {
        disable: false,
        sampleMessage: true,
        message: this.$t('inbox.sending')
      }

      bus.$emit('sample', this.notification)

      this.data = []
      Inbox.load().then((message) => {
        message.forEach(value =>
          this.data.push({
            id: value.id,
            to: value.to,
            from: value.from,
            messages: value.messages,
            title: value.title,
            fecha: value.date,
            inboxId: value.inboxId
          })
        )
      })
    },

    sampleReload(){

      const flag = this.inboxIdReload
      const respuesta = this.respuesta
      const today = new Date();
      const dd = String(today. getDate()). padStart(2, '0');
      const mm = String(today. getMonth() + 1). padStart(2, '0'); //January is 0!
      const yyyy = today. getFullYear();


      this.data.map(function(dato){
        
        if(dato.inboxId == flag){
            dato.messages.push({
              date: mm + '/' + dd + '/' + yyyy,
              message: respuesta,
              sender: flag,
              type: 'Send'
          })
        } else {
          console.log("No lo encontro")
        }
      })
      

      this.tituloMensaje = "",
      this.mensaje = ""
      this.respuesta = ""

      this.notification = {
        disable: false,
        sampleMessage: true,
        message: this.$t('inbox.sending')
      }
      
      bus.$emit('sample', this.notification)
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.done-row{
  background: #eaeaea;
}

table td, .table th{
  vertical-align: middle;
}

/* -- Error */
.error {
  color: rgb(190, 0, 0);
  margin: 5% auto;
  width: 100%;
  text-align: left;
  font-size: 12px;
}


/* -- Tables */

.tb-header thead {
  border-bottom: 2px solid #dee2e6;
}

.tb-header thead tr th {
  font-size: 12px;
  color: rgb(138, 138, 138);
}

.table td{
  border: none;
}

.t-border{
  border-bottom: 1px solid #dee2e6;
}

/* -- Tables */

/* -- Content  tables*/


.fullwidth{
  width: 100%;
  padding: 25px;
}

.group{
  width: 100%;
}

.input-form {
  border: 0;
  border-bottom: 1px solid #000;
  width: 100%;
  padding-bottom: 10px;
}

.btn-action{
  display: inline-block;
  background: #fff;
  color: #000;
  border: 1px solid #000;
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
  border-radius: 0;
  margin-top: 20%;
}

.infoMessage{
  text-align: left;
  margin: 20px auto;
  padding: 0;
}

.infoMessage p{
  margin-bottom: 15px;
}

.not-display{
  opacity: 0;
}

.info {
  text-align: left;
  width: 100%;
}

.info h1 {
  font-size: 20px;
  font-family: "plain regular", arial;
  display: inline-block;
}

.info h1 img {
  width: 20px;
  margin-right: 10px;
  margin-top: -8px;
}


.btn-action{
  display: inline-block;
  background: #fff;
  color: #000;
  border: 1px solid #000;
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
  border-radius: 0;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: left;
}

.info-user h1 {
  font-family: "plain medium", arial;
}

.info-user p {
  font-size: 12px;
}

.not-margin{
  padding: 0;
  margin: 5% 0 0 0;
}

.dropdown-toggle {
  font-size: 13px;
}

.btn-position {
  font-size: 10px;
  border-bottom: 1px solid #000;
  width: 25px;
  padding: 0;
  margin-right: 5px;
  text-transform: uppercase;
  font-family: "plain medium", arial;
}

.dropdown {
  display: inline-block;
  background: #fff;
  color: #000;
  border: 1px solid #000;
  margin-left: 15px;
  margin-right: 5px;
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
}

.dropdown-menu{
  background: #000;
  color: #fff;
  min-width: 20rem;
  padding: 20px;
  border: 0
}

.dropdown-item, .dropdown .dropdown-menu .has-link a{
  color: #fff;
  font-size: 12px;
  padding: 15px 0 15px 17px;
  opacity: 0.8;
  margin-left: 15px;
}

.principal-option{
  border-bottom: 1px solid;
  opacity: 1;
  margin-left: 0;
}

.principal-option img{
  width: 15px;
  vertical-align: middle;
  margin: 0 10px 3px -15px;
}

a.dropdown-item:hover, .dropdown .dropdown-menu .has-link a:hover, button.dropdown-item:hover {
  background-color: #000;
  color: #fff;
  text-decoration: underline;
}

.l-r {
  border-right: 1px solid rgb(221, 221, 221);
  padding-right: 15px;
}

.txt-left {
  text-align: left;
}

.txt-center {
  text-align: center;
}

.title-name {
  font-family: "plain medium", arial;
  font-size: 12px;
  margin-top: 5px;
}




small {
  margin: 5px 0;
  font-size: 0.775em;
}
.str {
  font-family: "plain medium", arial;
  font-size: 11px;
  text-decoration: underline;
}

.str-n {
  font-family: "plain medium", arial;
  font-size: 11px;
}

.margin-zero {
  margin: 0;
}

.padding-zero {
  padding: 0;
}

.delete_user {
  width: 25px;
  height: 25px;
  background-color: transparent;
  border: none;
  background: url("../assets/images/delete.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 20px;
}

.done {
  width: 25px;
  height: 25px;
  background-color: transparent;
  border: none;
  background: url("../assets/images/active.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 20px;
}

.image-play {
  width: 200px;
  height: 197px;
  object-fit: cover;
}

.form {
  padding: 5%;
  margin: 1% 0 0 0;
  background: #fff;
  border: 1px solid #000;
  height: 250px;
  display: flex;
}

.con-i {
  margin-top: 15px;
}

.form label {
  font-size: 11px;
  width: 120px;
  text-align: right;
  padding-right: 5px;
}

.form input {
  font-size: 12px;
  font-family: "plain medium", arial;
  width: 100px;
  border: 0;
  border-bottom: 1px solid #000;
}

.btn-action {
  border: 1px solid #000;
  background: #fff;
  padding: 5px 15px;
  font-size: 12px;
  margin-top: 5px;
}

.btn-action img {
  width: 20px;
  margin-right: 5px;
}

.inp{
  border: 0;
  border-bottom: 1px solid #000;
  width: 90%;
  font-size: 12px;
  margin-right: 5%;
  margin-top: 25px;
}

.inpf{
  border: 0;
  border-bottom: 1px solid #000;
  width: 100%;
  font-size: 12px;
  margin-right: 5%;
  margin-top: 25px;
}

.send-b{
  border: 1px solid #000;
  border-radius: 0;
  margin-left: 0px;
  font-size: 12px;
  padding: 5px 30px;
  margin-bottom: 9px;
  margin-top: 50px;
}


/* Mobile first queries */

/* Larger than Desktop HD */
@media (max-width: 1200px) {}

/* Larger than desktop */
@media (max-width: 992px) {}

/* Larger than tablet */
@media (max-width: 768px) {
  .inp{
    width: 100%;
  }
}

/* Larger than phablet */
@media (max-width: 550px) {}

/* Larger than mobile */
@media (max-width: 400px) {}

</style>
